import _orderBy from 'lodash/orderBy'

/**
 * @param   {object}   state
 *
 * @returns {object[]}
 */
const getOptions = state => state.options

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getOptionById = state => id =>
  state.options.find(option => option.id === id)

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getOptionsByStyleId = state => id =>
  _orderBy(
    state.options.filter(option => option.style_id === id),
    'index'
  )

/**
 * @param   {object}  state
 *
 * @returns {boolean}
 */
const getOptionUploadStatus = state => state.isUploadingOption

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getLatestDeliveryAssigned = state => () => state.latestDeliveryAssigned

/**
 * @param   {object}   state
 * @param   {object}   getters
 *
 * @param   {number}   boardId
 *
 * @returns {Function}
 */
const getOptionsByBoardId = (state, getters) => boardId => {
  const styles = getters.getStylesByBoardId(boardId)

  return styles.map(style => getters.getOptionsByStyleId(style.id)).flat()
}

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getOptionMetaFilters = state => state.optionMetaFilters

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getOptionsPaginatedPage = state => state.optionsPaginatedPage

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getOptionsPaginatedLimit = state => state.optionsPaginatedLimit

/**
 * @param   {object}  state
 *
 * @returns {boolean}
 */
const getHasReachedOptionsPaginatedEnd = state =>
  state.hasReachedOptionsPaginatedEnd

/**
 * @type {object}
 */
const getters = {
  getOptions,
  getOptionById,
  getOptionsByStyleId,
  getOptionUploadStatus,
  getLatestDeliveryAssigned,
  getOptionsByBoardId,
  getOptionMetaFilters,
  getOptionsPaginatedPage,
  getOptionsPaginatedLimit,
  getHasReachedOptionsPaginatedEnd
}

export default getters
